var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.25C13.5 12.1111 7.25 16.2778 7.25 16.2778C7.25 16.2778 1 12.1111 1 7.25C1 5.5924 1.65848 4.00268 2.83058 2.83058C4.00268 1.65848 5.5924 1 7.25 1C8.9076 1 10.4973 1.65848 11.6694 2.83058C12.8415 4.00268 13.5 5.5924 13.5 7.25Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2513 9.33366C8.4019 9.33366 9.33464 8.40092 9.33464 7.25033C9.33464 6.09973 8.4019 5.16699 7.2513 5.16699C6.10071 5.16699 5.16797 6.09973 5.16797 7.25033C5.16797 8.40092 6.10071 9.33366 7.2513 9.33366Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocate);
export default __webpack_public_path__ + "static/media/locate.cc981d1d6d3c945d5f3967200e282efb.svg";
export { ForwardRef as ReactComponent };